import { render, staticRenderFns } from "./AddEditSponsorDetails.vue?vue&type=template&id=e9b47598&scoped=true"
import script from "./AddEditSponsorDetails.vue?vue&type=script&lang=js"
export * from "./AddEditSponsorDetails.vue?vue&type=script&lang=js"
import style0 from "./AddEditSponsorDetails.vue?vue&type=style&index=0&id=e9b47598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b47598",
  null
  
)

export default component.exports